module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    staticClass: "fluid"
  }, [_c('c-confirm-dialog', {
    attrs: {
      "titulo": "Duplicar ação?"
    },
    on: {
      "yes": function($event) {
        return _vm.duplicarAcao()
      }
    },
    model: {
      value: (_vm.dialogDuplicar),
      callback: function($$v) {
        _vm.dialogDuplicar = $$v
      },
      expression: "dialogDuplicar"
    }
  }, [_vm._v("\n    A duplicação importa somente parte do conteúdo. Ressaltamos a necessidade de revisão, atualização e complementação das informações da nova ação.\n  ")]), _vm._v(" "), _c('v-layout', {
    attrs: {
      "align-center": "",
      "justify-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs10": ""
    }
  }, [_c('v-card', {
    staticClass: "text-xs-center"
  }, [_c('basic-toolbar', {
    attrs: {
      "title": 'Duplicar Ação de Extensão'
    }
  }), _vm._v(" "), _c('v-card-text', [_c('v-form', {
    ref: "form",
    model: {
      value: (_vm.formularioValido),
      callback: function($$v) {
        _vm.formularioValido = $$v
      },
      expression: "formularioValido"
    }
  }, [_c('v-container', [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs9": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Número da ação de extensão a ser duplicada",
      "required": "",
      "rules": _vm.regrasBasicas,
      "max-height": "400"
    },
    model: {
      value: (_vm.pesquisa.numero),
      callback: function($$v) {
        _vm.$set(_vm.pesquisa, "numero", $$v)
      },
      expression: "pesquisa.numero"
    }
  })], 1), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "primary",
      "text": ""
    },
    on: {
      "click": _vm.pesquisarProjetoSIEX
    }
  }, [_vm._v("Pesquisar")])], 1), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.duplicacao && _vm.duplicacao.titulo),
      expression: "duplicacao && duplicacao.titulo"
    }]
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Título (atualizar o título da ação para que a duplicação seja realizada)",
      "required": "",
      "rules": _vm.tituloRules,
      "max-height": "400",
      "counter": "150"
    },
    model: {
      value: (_vm.duplicacao.titulo),
      callback: function($$v) {
        _vm.$set(_vm.duplicacao, "titulo", $$v)
      },
      expression: "duplicacao.titulo"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs11": "",
      "sm5": ""
    }
  }, [_c('v-select', {
    attrs: {
      "label": "Tipo de público-alvo",
      "items": _vm.listaTipoPublico,
      "item-text": "descricao",
      "item-value": "item",
      "prepend-icon": "dashboard",
      "max-height": "400",
      "return-object": "",
      "required": "",
      "autocomplete": "",
      "rules": _vm.regrasBasicas
    },
    model: {
      value: (_vm.duplicacao.tipoPublico),
      callback: function($$v) {
        _vm.$set(_vm.duplicacao, "tipoPublico", $$v)
      },
      expression: "duplicacao.tipoPublico"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs11": "",
      "sm5": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Público-alvo estimado",
      "mask": "#########",
      "required": "",
      "rules": _vm.regrasBasicas,
      "max-height": "20"
    },
    model: {
      value: (_vm.duplicacao.publicoAlvo),
      callback: function($$v) {
        _vm.$set(_vm.duplicacao, "publicoAlvo", $$v)
      },
      expression: "duplicacao.publicoAlvo"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs11": "",
      "sm5": ""
    }
  }, [_c('c-date-menu', {
    attrs: {
      "label": "Data de início",
      "required": "",
      "rules": _vm.regrasBasicas
    },
    model: {
      value: (_vm.duplicacao.dataInicio),
      callback: function($$v) {
        _vm.$set(_vm.duplicacao, "dataInicio", $$v)
      },
      expression: "duplicacao.dataInicio"
    }
  })], 1), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs11": "",
      "sm5": ""
    }
  }, [_c('c-date-menu', {
    attrs: {
      "label": "Data de conclusão",
      "required": "",
      "rules": _vm.regrasBasicas
    },
    model: {
      value: (_vm.duplicacao.dataConclusao),
      callback: function($$v) {
        _vm.$set(_vm.duplicacao, "dataConclusao", $$v)
      },
      expression: "duplicacao.dataConclusao"
    }
  })], 1)], 1), _vm._v(" "), _c('p', {
    staticClass: "mt-3"
  })], 1)], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "color": "primary",
      "text": ""
    },
    on: {
      "click": function($event) {
        return _vm.$router.go(-1)
      }
    }
  }, [_vm._v("Cancelar")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "primary",
      "text": "",
      "disabled": !_vm.formularioValido
    },
    on: {
      "click": _vm.botaoDuplicarAcao
    }
  }, [_vm._v("Duplicar")])], 1)], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f2c7837a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/editar-projeto/duplicar-projeto.vue
// module id = 447
// module chunks = 0